var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.84912 12.375C3.86539 12.375 5.49991 14.0095 5.49991 16.0258",
    stroke: "#292442",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16.0258V15.9416C16.5 13.9718 18.0968 12.375 20.0666 12.375",
    stroke: "#292442",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49991 3.22266C5.49991 5.23894 3.86539 6.87345 1.84912 6.87345",
    stroke: "#292442",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3.22266C16.5 5.22128 18.1216 6.8448 20.1138 6.87307",
    stroke: "#292442",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 3.20837H7.33325C4.74052 3.20837 3.44417 3.20837 2.63871 4.01383C1.83325 4.81929 1.83325 6.11565 1.83325 8.70837V10.5417C1.83325 13.1344 1.83325 14.4308 2.63871 15.2362C3.44417 16.0417 4.74052 16.0417 7.33325 16.0417H14.6666C17.2593 16.0417 18.5556 16.0417 19.3611 15.2362C20.1666 14.4308 20.1666 13.1344 20.1666 10.5417V8.70837C20.1666 6.11565 20.1666 4.81929 19.3611 4.01383C18.5556 3.20837 17.2593 3.20837 14.6666 3.20837Z",
    stroke: "#292442",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58325 18.7916H17.4166",
    stroke: "#292442",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 9.625C13.75 11.1438 12.5188 12.375 11 12.375C9.48117 12.375 8.25 11.1438 8.25 9.625C8.25 8.10622 9.48117 6.875 11 6.875C12.5188 6.875 13.75 8.10622 13.75 9.625Z",
    stroke: "#292442",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/finance.cd6db4cc8592aeb7dcd3f420170e5f20.svg";
export { ForwardRef as ReactComponent };